import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findAllProvince({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllProvince`).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findAllBatchByProvinceId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllBatchByProvinceId`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  generationScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/smartReport/generationScheme`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findAllSpecialityCategoryAndSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllSpecialityCategoryAndSpeciality`, {
        params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  // 获取专业类别
  findSpecialityType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/art/smartReport/findSpecialityType",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
